<template>
  <div style="width: 100%;height: 100%;" class="body2">
    <div style="height: 150px" class="top_bg">
      <headers pageType="convenientIndex"></headers>
      <div class="position">
        <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <span>便民查询</span></p></div>
      </div>
    </div>
    <div class="fixed">
      <fixedDiv></fixedDiv>
    </div>
  <!--  <div class="serverqh wraper" style="margin-top: 10px;">
      <h2 class="tit"></h2>
      <ul style="display: flex;justify-content: space-between">
        <div v-for="(item,index) in orgTypeList">
        <li @click="urlTo('orgSearch',{code:item.code,name:item.name})"   class="noticeIndex_li" ><a href="javascript:void(0)" ><p>{{item.name}}</p></a></li>

        </div>
      </ul>
      <ul style="display: flex;justify-content: space-between">
        <div v-for="(item,index) in SocialTypeList">
          <li @click="urlTo('socialSearch',{code:item.code,name:item.name})"   class="noticeIndex_li" ><a href="javascript:void(0)" ><p>{{item.name}}</p></a></li>

        </div>
        <li @click="urlTo('communitySearch',{code:'社区',name:'社区信息'})"    class="noticeIndex_li" ><a href="javascript:void(0)" ><p>社区信息查询</p></a></li>
        <li @click="urlTo('communitySearch',{code:'村庄',name:'村庄信息'})"    class="noticeIndex_li" ><a href="javascript:void(0)" ><p>村庄信息查询</p></a></li>

      </ul>

    </div>-->

    <div style="margin-top: 65px" class="wraper">
      <div  class="civil_part1">
        <h2 class="tit">民政对象</h2>
        <ul style="margin-bottom: 100px">
<!--          <li style="padding-right: 15px;margin-bottom: 40px"  ><a href="javascript:void(0)"   @click="urlTo('userSearch')" class="civil_icon1"><img src="../../static/new_imgs/zhcx.png"><span>综合查询</span></a></li>-->
          <li style="padding-right: 15px;margin-bottom: 40px"  ><a href="javascript:void(0)"   @click="urlTo('enjoyTreatment')" class="civil_icon7"><img src="../../static/new_imgs/dycx.png"><span>待遇查询</span></a></li>
          <li style="padding-right: 15px;margin-bottom: 40px"  ><a href="javascript:void(0)"   @click="urlTo('payList')" class="civil_icon5"><img src="../../static/new_imgs/zjffls.png"><span>资金发放历史</span></a></li>
        </ul>
      </div>
    </div>
    <div class="clear"></div>


    <div class="wraper">
      <div  class="civil_part1">
        <h2 class="tit">办事机构</h2>
        <ul style="margin-bottom: 100px">
        <li style="padding-right: 15px;margin-bottom: 40px" ><a href="javascript:void(0)"   @click="urlTo('orgSearch',{code:'901010108',name:'民政办事网点'})"  class="civil_icon9"><img src="../../static/new_imgs/sqxxcx.png"><span>民政办事网点</span></a></li>
        <li style="padding-right: 15px;margin-bottom: 40px" ><a href="javascript:void(0)"   @click="urlTo('orgSearch',{code:'901010101',name:'养老机构'})"  class="civil_icon9"><img src="../../static/new_imgs/yljg.png"><span>养老机构</span></a></li>
        <li style="padding-right: 15px;margin-bottom: 40px" ><a href="javascript:void(0)"   @click="urlTo('orgSearch',{code:'901010103',name:'儿童福利机构'})"  class="civil_icon9"><img src="../../static/new_imgs/kjet.png"><span>儿童福利机构</span></a></li>
        <li style="padding-right: 15px;margin-bottom: 40px" ><a href="javascript:void(0)"   @click="urlTo('orgSearch',{code:'901010104',name:'未成年人保护中心'})"  class="civil_icon8"><img src="../../static/new_imgs/shjzz.png"><span>未成年人保护中心</span></a></li>
        <li style="padding-right: 15px;margin-bottom: 40px" ><a href="javascript:void(0)"   @click="urlTo('orgSearch',{code:'901010106',name:'社会救助站'})"  class="civil_icon7"><img src="../../static/new_imgs/jhdjyy.png"><span>社会救助站</span></a></li>
        <li style="padding-right: 15px;margin-bottom: 40px" ><a href="javascript:void(0)"   @click="urlTo('orgSearch',{code:'901010107',name:'社区服务站'})"  class="civil_icon7"><img src="../../static/new_imgs/shtt.png"><span>社区服务站</span></a></li>
        <li style="padding-right: 15px;margin-bottom: 40px" ><a href="javascript:void(0)"   @click="urlTo('marriageQuery',{code:'901010102',name:'婚姻登记机构'})"  class="civil_icon7"><img src="../../static/new_imgs/jhdjyy.png"><span>婚姻登记机构</span></a></li>
       <!-- <li style="padding-right: 15px;margin-bottom: 40px" ><a href="javascript:void(0)"   @click="urlTo('orgSearch',{code:'901010105',name:'慈善机构'})"  class="civil_icon1"><img src="../../static/new_imgs/csjg.png"><span>慈善机构</span></a></li>
        -->
          <li style="padding-right: 15px;margin-bottom: 40px" ><a href="javascript:void(0)"   @click="urlTo('institutionalQuery',{type:'1',name:'殡仪馆'})"  class="civil_icon6"><img src="../../static/images/byg.png"><span>殡仪馆</span></a></li>
        <li style="padding-right: 15px;margin-bottom: 40px" ><a href="javascript:void(0)"   @click="urlTo('institutionalQuery',{type:'2',name:'经营性公墓'})"  class="civil_icon2"><img src="../../static/images/jyxgm.png"><span>经营性公墓</span></a></li>
        <li style="padding-right: 15px;margin-bottom: 40px" ><a href="javascript:void(0)"   @click="urlTo('institutionalQuery',{type:'3',name:'公益性公墓'})"  class="civil_icon9"><img src="../../static/images/gyxgm.png"><span>公益性公墓</span></a></li>
        <li style="padding-right: 15px;margin-bottom: 40px" ><a href="javascript:void(0)"   @click="urlTo('orgSearch',{code:'901010109',name:'康复辅助器具机构'})"  class="civil_icon7"><img src="../../static/images/kffzqjjg.png"><span>康复辅助器具机构</span></a></li>

        </ul>
      </div></div>
  <!--  <div class="wraper">
      <div  class="civil_part1">
        <h2 class="tit">办事机构</h2>
        <ul style="margin-bottom: 100px">
        <li style="padding-right: 15px;margin-bottom: 40px" ><a href="javascript:void(0)"   @click="urlTo('communitySearch',{code:'社区',name:'办事网点'})"  class="civil_icon2"><img src="../../static/new_imgs/sqxxcx.png"><span>办事网点查询</span></a></li>
          <li style="padding-right: 15px;margin-bottom: 40px" v-for="(item,index) in orgTypeList"><a href="javascript:void(0)"  @click="urlTo('orgSearch',{code:item.code,name:item.name})"  :class="'civil_icon'+index"><img :src="'static/new_imgs/'+item.code+'.png'"><span>{{item.name}}</span></a></li>

        </ul>
      </div></div>-->
    <div class="wraper">
      <div  class="civil_part1">
        <h2 class="tit">社会组织</h2>
        <ul style="margin-bottom: 100px">
          <li style="padding-right: 15px;margin-bottom: 40px" v-for="(item,index) in SocialTypeList "><a href="javascript:void(0)"  @click="urlTo('socialSearch',{code:item.code,name:item.name})"  :class="'civil_icon'+index"><img :src="'static/new_imgs/'+item.code+'.png'"><span>{{item.name}}</span></a></li>

        </ul>
      </div></div>

    <div class="clear"></div>
    <footers></footers>
  </div>

</template>

<script>
  import headers from "../components/Headers";
  import fixedDiv from "../components/FixedDiv";
  import footers from "../components/Footer";
  export default {
    name: "public-index",
    components:{
      headers,fixedDiv,footers
    },
    data() {
      return {
        condition:'',
        active: 'publicIndex',
        width:document.body.clientWidth+'px',
        height:document.body.clientHeight+'px',
        activeName: 'zcwj',
        infoData:{},
        tzgg:[],
        zcwj:[],
        orgTypeList:[],
        SocialTypeList:[],
        yggs:[],
      }
    } ,
    watch: {
      width(n,o){
        alert(n+'w')
      },
      height(n,o){
        alert(n+'h')
      }
    },
    mounted(){

    },
    created(){
      this.getOrgServiceType();
      this.getSocialServiceType();
    },
    methods: {
      getSocialServiceType(){
        var tt=this;
        this.$https.post("api/socialService/getSocialServiceType.do",{},response=>{
          if (response.status === 200 && response.data.code===200 && response.data.data) {
            tt.SocialTypeList=response.data.data
          }
        })
      },
      getOrgServiceType(){
        var tt=this;
        this.$https.post("api/orgservice/getOrgServiceType.do",{},response=>{
          if (response.status === 200 && response.data.code===200 && response.data.data) {
            tt.orgTypeList=response.data.data
          }
        })
      },
      handleClick(tab, event) {
        //异步获取数据
        this.initNews(tab.name);
      },

      onChange(index) {
        //  Notify({ type: 'primary', message: index+"_"});
        this.$router.push(index);
      },
      gotoReg(){
        this.$router.push("/peopleReg");

      },
      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      },
      urlTo2(url,params){
        this.$message({
          message: '暂未开放',
          type: 'warning'
        });
        // this.$router.push({path:url,query:params||{}});
      }

    }
  }



</script>
<style>
  .info .el-tabs__item.is-active {
    background: url(../../static/images/tit_bg_on.png) repeat-x bottom left;
    color: #2c62ec;
    font-weight: bold;
  }
  .info .el-tabs__item  {
    width:100px;
    text-align: center;
    font-size: 18px;
    padding: 0 0px;
    margin-left: 20px;
    line-height: 65px;
    height: 65px;
  }
  .info .el-tabs__active-bar{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ConvenientIndex.vue